import * as R from "ramda";
import { message } from "antd";
import { useCallback } from "react";

import ajaxUtil from "@/util/ajax";
import {
  getKey,
  uploadFile,
  getMediaTypeByFile,
} from "../widgets/upload-resource-util";
import { uploadMediaOssUrl } from "./upload-resource";
import { getBaseNameOfFile } from "./upload-resource-modal";

const { ajaxv2 } = ajaxUtil;

export const registerResource = (file, key, orderId, userId, extra = {}) => {

  const params = {
    url: `/api/v2/aliyun/ice/register`,
    data: {
      url: ("/" + key).replace("//", "/"),
      mediaType: getMediaTypeByFile(file),
      orderId: parseInt(orderId, 10),
      category: 1,
      auth: parseInt(userId, 10),
      name: getBaseNameOfFile(file.name),
      hidden: 1,
      ...extra,
    },
    method: "POST",
  };

  // noinspection NonAsciiCharacters
  return ajaxv2(params);
  /**
   * {
   *     "url": "/80667/102616/o7oa0yfnh9.wav",
   *     "mediaType": "audio",
   *     "orderId": 80667,
   *     "category": 1,
   *     "auth": 102616,
   *     "name": "蔡琴+-+渡口【有间音乐】.wav",
   *     "hidden": 0,
   *     "channel": 2,
   *     "options": { "coverUrl": "" }
   *   }
   */
};

/***
 url: https://....../80667/102616/o7oa0yfnh9.wav
 **/
export const registerVideoResourceByUrl = (
  url,
  orderId,
  userId,
  extra = {}
) => {
  const pathnameOfUrl = new URL(url).pathname;
  return ajaxv2({
    url: `/api/v2/aliyun/ice/register`,
    data: {
      url: pathnameOfUrl,
      mediaType: "video",
      orderId: parseInt(orderId, 10),
      category: 1,
      auth: parseInt(userId, 10),
      name: "视频链接上传",
      hidden: 1,
      ...extra,
    },
    method: "POST",
  });
};


export const resourceKeyGenerator = (props)=>{
  const galleryId = R.pathOr("", ["match", "params", "galleryid"], props);
  const orderId = R.pathOr("", ["match", "params", "orderid"], props);
  const userId = R.pathOr("", ["user", "id"], props);
  const file = R.pathOr({}, ["file"], props);
  return getKey(orderId, galleryId, userId, file);
}

const useCustomRequest = (props) => {
  //  外部参数
  const afterDone = R.pathOr(R.T, ["afterDone"], props);
  const keyGenerator = R.pathOr(resourceKeyGenerator, ["keyGenerator"], props);

  return useCallback(
    async ({ file, onSuccess, onError }) => {
      const key = keyGenerator({ ...props, file });
      file.url = uploadMediaOssUrl + key;
      message.loading({
        content: `${file.name} 正在上传中(0%)....`,
        key,
        duration: 0,
      });
      try {
        await uploadFile(key, file, (percent) => {
          message.loading({
            content: `${file.name} 正在上传中(${Math.round(
              percent * 100
            )}%)....`,
            key,
            duration: 0,
          });
        });
        onSuccess(null, file);
        message.success({
          content: `${file.name} 上传成功`,
          key,
        });
        afterDone(file);
      } catch (error) {
        onError(error);
      }
    },
    [props, afterDone]
  );
};

export default useCustomRequest;



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/useCustomRequest.js